import type {
  AppointmentStatus,
  OpportunitySort,
  TrackingStatus,
} from '@fv/models'

import type { OppListingStatus } from './features/opportunities/types'

export const bucketCountKeys = {
  all: ['bucket-counts'] as const,
  account: (id?: string) =>
    !id ? bucketCountKeys.all : [...bucketCountKeys.all, 'account', id],
  byStartDate: (startDate: string) =>
    [...bucketCountKeys.all, startDate] as const,
}

export interface OppListFilterKeyParams {
  status: OppListingStatus
  accountId?: string
  sortBy?: OpportunitySort
  sortDirection?: 1 | -1
  trackingStatus?: TrackingStatus
  appointmentStatus?: AppointmentStatus
}
export const opportunityQueryKeys = {
  all: ['opportunities'],
  search: () => [...opportunityQueryKeys.all, 'searchResults'],
  bySearchText: (text: string) => [...opportunityQueryKeys.search(), text],
  byStatus: (status: OppListingStatus) => [...opportunityQueryKeys.all, status],
  byFilter: ({
    status,
    accountId,
    sortBy,
    sortDirection,
    trackingStatus,
    appointmentStatus,
  }: OppListFilterKeyParams) => [
    ...opportunityQueryKeys.byStatus(status),
    accountId ?? '',
    sortBy ?? '',
    sortDirection ?? 1,
    trackingStatus ?? '',
    appointmentStatus ?? '',
  ],
}

export const quoteRequestKeys = {
  all: ['quoteRequest'],
  id: (id: string) => [...quoteRequestKeys.all, id],
}

export const carrierContextKeys = {
  all: ['carrierContext'],
  id: (id: string) => [...carrierContextKeys.all, id],
}

export const userContextKeys = {
  all: ['userContext'],
}

export const messagesQueryKeys = {
  all: ['messages'],
  load: (loadId: string) => [...messagesQueryKeys.all, loadId],
}

export const quoteQueryKeys = {
  all: 'quotes',
  load: (loadId: string) => [...quoteQueryKeys.all, loadId],
}
